import React from "react";
import { companyLogoImg } from "../data/data";

export default function CompanyLogo(){
    return(
        <div className="row justify-content-center">
            {companyLogoImg.slice(0,6).map(( item, index ) =>{
                return(
                <div className="col-lg-2 col-md-2 col-6 text-center py-4 py-md-0" key={index}>
                    <img src={item} className="avatar avatar-client" alt=""/>
                </div>
                )
            })}
        </div>
    )
}